<template>
<div class="login-page">

    <!-- Logo & Tajuk (KEKAL) -->
    <div class="logo-wrapper">
        <img src="img/brand/jata-negara3.png" alt="Jata Negara" class="jata-logo" />
        <h3 class="logo-title">
            SISTEM <br /> SEMAKAN GAJI
        </h3>
    </div>

    <!-- Login -->
    <div class="login-container">
        <h1 class="login-header">
            <center>LOG MASUK</center>
        </h1>

        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <b-form @submit.prevent="handleSubmit(onSubmit)">

                <base-input alternative class="mb-3" label="No Kad Pengenalan" :rules="{ required: true }" :customMessages="{ required: 'No Kad Pengenalan perlu diisi' }" prepend-icon="ni ni-credit-card" placeholder="No Kad Pengenalan" v-model="Pengguna.icno" />

                <base-input alternative class="mb-3" label="Kata Laluan" type="password" :rules="{ required: true, min: 6 }" :customMessages="{ required: 'Kata Laluan perlu diisi' }" prepend-icon="ni ni-lock-circle-open" placeholder="Kata Laluan" v-model="Pengguna.password" />

                <div class="text-right">
                    <b-button :disabled="show" variant="primary" type="submit" class="btn-login">
                        <span v-if="!show">Log Masuk</span>
                        <span v-else>Sila tunggu...</span>
                    </b-button>
                </div>

            </b-form>
        </validation-observer>
    </div>

    <!-- Footer -->
    <footer class="footer">
        <p>&copy; 2024 SISTEM SEMAKAN GAJI. HAK CIPTA TERPELIHARA.</p>
    </footer>

</div>
</template>

<script>
import PenggunaService from "@/services/PenggunaService.js";
import store from "@/store";
import swal from "sweetalert2";
export default {
    data() {
        return {
            show: false,
            Pengguna: {
                icno: "",
                password: "",
            },
        };
    },
    methods: {
        onSubmit() {
            this.show = true;
            PenggunaService.loginPengguna(this.Pengguna)
                .then((resp) => {
                    //store.Pengguna = resp.data;
                    this.$store.commit('saveSingleUserObj',
                        resp.data);
                    console.log("after commit store.pengguna", store.state.Pengguna);
                    console.log("resp.data set to => store.pengguna", resp.data);

                    //this.$router.push('/modul/selenggara-item-dashboard/kod-program')
                    console.log("after login store.pengguna", store.state.Pengguna);
                })
                .catch((err) => {
                    console.log("err loginPengguna:", err);
                    let errObj = err.response.data;
                    let swalTitle = "Login Tidak Berjaya.";
                    let swalText = "Sistem mengalami gangguan buat masa ini.";
                    if (err.response.status === 401) {
                        swalTitle = "";
                        swalText = errObj.errmsg;
                    }
                    swal.fire({
                        title: swalTitle,
                        text: swalText,
                        buttonsStyling: true,
                        icon: "error",
                    });
                })
                .then(() => {
                    //console.log('this.Pengguna test login',this.Pengguna)
                    this.show = false;
                    PenggunaService.testLogin(this.Pengguna).then(resp => {
                        console.log('test login', resp.data)
                        store.state.Pengguna.ev_id = resp.data['session_id']
                        localStorage.setItem('ev_id', resp.data['session_id']);
                        console.log("store.state.Pengguna.ev_id", store.state.Pengguna)
                    }).then(() => {
                        // ini untuk beritahu jika status pengguna tidak aktif akan perlu redirect ke login
                        console.log("store.state.Pengguna.userStatusID INI", store.state.Pengguna.userStatusID)
                        if (store.state.Pengguna.userStatusID == 1) {
                            this.$router.push("/dashboardSkg");
                        } else {
                            this.$router.push("/login");
                        }
                        //this.$router.push("/dashboardSkg");
                        console.log('after login get this ev_id: ', store.state.Pengguna.ev_id)
                    }).then(() => {
                        let QueryObj = {
                            session_id: store.state.Pengguna.ev_id
                        }
                        console.log("QueryObj", QueryObj)
                        PenggunaService.loadSession(QueryObj).then((resp) => {
                            console.log('Sessions: ', resp.data)
                        })
                    })
                });
        },
        onHidden() {
            // Return focus to the button once hidden
            this.$refs.button.focus();
        },
    },
};
</script>

<style scoped>
.login-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;

      /* Warna asas */
  background-color: #021b42;

  background-image:
    repeating-linear-gradient(
      45deg,
      rgba(241, 239, 234, 0.06),
      rgba(248,231,189,0.06) 1px,
      transparent 1px,
      transparent 60px
    ),
    repeating-linear-gradient(
      -45deg,
      rgba(248,231,189,0.06),
      rgba(248,231,189,0.06) 1px,
      transparent 1px,
      transparent 60px
    );
}

/* LOGO KEKAL STYLE */
.logo-wrapper {
    margin-top: 40px;
    text-align: center;
}

.jata-logo {
    width: 190px;
    /* sama macam asal */
}

.logo-title {
  font-family: "Playfair Display", "Times New Roman", serif;
  font-size: 60px;
  margin-top: 10px;
  font-weight: 700;
  letter-spacing: 3px;
  line-height: 1.1;
  color: rgb(248, 231, 189);
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.35);
}

/* LOGIN BOX */
.login-header {
  font-family: "Montserrat", "Segoe UI", sans-serif;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 4px;
  color: rgb(252, 251, 250);
  margin-bottom: 25px;
  text-align: center;
}

.login-container {
    margin-top: 40px;
    width: 100%;
    max-width: 420px;
}

.base-input label {
  font-size: 47px;
  font-weight: 700;
  letter-spacing: 1.2px;
  color: #ffffff;
}

.base-input input {
  font-size: 18px;
  border-radius: 8px;
  background-color: rgba(255,255,255,0.95);
}

.base-input input::placeholder {
  font-size: 15px;
  color: #888;
}

/* FOOTER KEKAL BAWAH */
.footer {
    width: 100%;                  /* penuh ke kiri & kanan */
    background-color: #ffffff;    /* putih penuh */
    color: #2c2e34;               /* warna teks gelap supaya jelas */
    font-weight: 700;             /* bold */
    text-align: center;
    padding: 15px 0;
    box-sizing: border-box;
    position: relative;
}
/* Hanya hide navbar-toggler pada login page */
.login-page .navbar-toggler {
  display: none !important;
}


/* 📱 MOBILE TUNING (tak ubah desktop) */
@media (max-width: 576px) {
    .logo-wrapper {
        margin-top: 20px;
    }

    .login-container {
        padding: 0 15px;
    }

    .jata-logo {
        width: 70px;
    }

        .login-page .navbar-toggler{  
        display: none !important;
    }
    .login-page .navbar-profile {  /* ganti .navbar-profile ikut class logo/profile pic sebenar */
        display: none !important;
    }

      .navbar-toggler {
    display: none !important;
  }
    
}
</style>
